var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('van-nav-bar',{attrs:{"title":_vm.title}}),_c('van-empty',{attrs:{"description":"移动端功能开发中"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }